import React, { useCallback, useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { cn } from "helper/cn";

import Tick from "../../../../../../assets/customSVG/Tick";
import Xmark from "../../../../../../assets/customSVG/Xmark";
import Loader from "../../../../../../components/commonComponents/Loader/Index";
import Alert from "../../../../../../components/commonComponents/modals/Alert";
import useToggle from "../../../../../../hooks/useToggle";
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../../../test/jest-redux-hooks";
import Icons from "../../Icons";

import New from "./New";
import {
  getFbAds,
  getMetaAds,
  getMetaCampaignNames,
  updateInitialTrigger,
} from "../../../../api/sequence";
import { useQuery } from "@tanstack/react-query";

export default function AdsTrigger({
  node,
  originalData,
  onChange,
  toggleNodeEditMode,
  allowToEditFlow,
  removeEdges,
  sequenceDetails,
}) {
  const { id, uniq_id, trigger_type, data, settings } = node;

  const { currentBrand, toggleToast } = useAspSelector((state) => state.app);
  const { sequence_id, campaign_id } = useParams();
  const dispatch = useAspDispatch();

  const [isUpdating, setIsUpdating] = useToggle(false);

  const [showConfirm, setShowConfirm] = useToggle();

  const [allowToRemoveEdges, setAllowToRemoveEdges] = useToggle(false);

  const showSubmit = useCallback(() => {
    const isValidAd = data?.settings?.campaign_ads;
    const isValidName = data?.settings?.campaign_name;
    const isValidAdChange = data?.settings?.fb_datas?.name;

    return isValidAd && isValidName && isValidAdChange;
  }, [node]);

  const metaCampaignsQuery = useQuery({
    queryKey: ["metaCampaigns", currentBrand?.brand_id],
    queryFn: () => getMetaCampaignNames(currentBrand?.brand_id),
    enabled: !!currentBrand?.brand_id && !!node,
  });

  const metCampignAds = useQuery({
    queryKey: [
      "metaAds",
      currentBrand?.brand_id,
      node?.data?.settings?.fb_campaign_id,
    ],
    queryFn: () =>
      getMetaAds(currentBrand?.brand_id, node?.data?.settings?.fb_campaign_id),
    enabled:
      !!currentBrand?.brand_id &&
      !!node?.data?.settings?.fb_campaign_id &&
      !!node,
  });

  const metaFbAds = useQuery({
    queryKey: [
      "metaAds",
      currentBrand?.brand_id,
      node?.data?.settings?.fb_ad_set_id,
    ],
    queryFn: () =>
      getFbAds(currentBrand?.brand_id, node?.data?.settings?.fb_ad_set_id),
    enabled:
      !!currentBrand?.brand_id &&
      !!node?.data?.settings?.fb_ad_set_id &&
      !!node,
  });

  const campaignsName = metaCampaignsQuery?.data?.data?.campaigns;
  const campaignsAds = metCampignAds?.data?.data?.ad_sets;
  const fbAds = metaFbAds?.data?.data?.ads;

  const handleYes = async () => {
    setIsUpdating(true);
    try {
      const allowToSubmit = showSubmit();

      // if (allowToSubmit?.isExisting && allowToSubmit?.isAlreadySelected) {
      //   toggleNodeEditMode({
      //     id: node?.id,
      //     uniqId: node?.uniq_id,
      //     value: "false",
      //     defaults: node?.settings?.defaults,
      //   });
      // } else {
      try {
        let payload = {
          brand_id: currentBrand?.brand_id,
          campaign_id: campaign_id,
        };

        if (allowToSubmit) {
          payload = {
            ...payload,
            // trigger_type: trigger_type?.toLowerCase(),
            trigger_type: "META_AD",
            save: true,
            remove_edges: true,
          };

          const res = await updateInitialTrigger(sequence_id, node?.uniq_id, {
            ...payload,
            details: node?.data?.settings?.fb_datas,
            defaults: node?.settings?.defaults,
          });

          if (res?.status === 200) {
            setShowConfirm(false);
            onChange({
              type: "UPDATE_NODE_DATA",
              id: node?.uniq_id,
              data: res?.data?.data?.[0],
            });

            onChange({
              type: "UPDATE_DATA",
              data: { selectedNode: null },
            });
          } else {
            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content: res?.response?.data?.message,
                  status: "Error",
                  duration: "",
                },
              ])
            );
          }
        } else {
          if (data?.broadcast_id) {
            // await updateQuickBroadcast();
            if (
              selectedTemplate &&
              data?.settings?.template_id !== selectedTemplate?.id
            )
              removeEdges(node?.uniq_id);

            onChange({
              type: "UPDATE_DATA",
              data: { selectedNode: null },
            });
          } else {
            // await createQuickBroadcast();
            // removeEdges(node?.uniq_id);
          }
        }

        setIsUpdating(false);
        // onChange({
        //   type: 'UPDATE_DATA',
        //   data: { selectedNode: null },
        // });
      } catch (error) {
        console.warn(error);
      }
    } catch (error) {
      // }
      console.warn(error);
    }
  };

  return (
    <div className="w-full flex-1 min-w-full max-w-[17rem] h-full rounded-2xl overflow-hidden select-none">
      <div className="">
        <div
          className={cn(
            "flex items-center justify-between gap-5 px-5 py-2.5 bg-[#0064E0] text-white"
          )}
        >
          <div className="flex items-center gap-5">
            <Icons
              keyProp={node?.label?.toLowerCase()}
              bgProp={"transparent"}
            />
            <p className="capitalize">{node?.label?.replace("(CTWA)", "")}</p>
          </div>
          <div
            className="size-4 flex items-center justify-center cursor-pointer"
            onClick={() => {
              toggleNodeEditMode({
                id: node?.id,
                uniqId: node?.uniq_id,
                value: "false",
                defaults: node?.settings?.defaults,
              });
              onChange({
                type: "UPDATE_NODE",
                id: node?.uniq_id,
                key: "data",
                data: node?.status === "NEW" ? null : originalData?.data,
              });
            }}
          >
            <Xmark color="white" width={12} height={12} />
          </div>
        </div>

        <div className="w-full px-6 pt-6 pr-1 bg-white">
          <div className="w-full max-h-[400px] pr-6 flex flex-col gap-5 overflow-y-scroll listScroll">
            <p>
              Your selected page and ad account will host your ad set and ad.
            </p>
            <New
              data={node}
              onChange={onChange}
              allowToEditFlow={allowToEditFlow}
              sequenceDetails={sequenceDetails}
              campaignsName={campaignsName}
              campaignsAds={campaignsAds}
              fbAds={fbAds}
            />
          </div>
        </div>

        <div className="w-full h-fit flex justify-end px-6 py-2.5 bg-white">
          <button
            className={cn(
              "w-14 h-8  flex items-center justify-center  px-4 py-1 rounded-md",
              showSubmit()
                ? "cursor-pointer opacity-100 bg-[var(--new-primary)] text-white"
                : "opacity-50 cursor-not-allowed bg-[var(--BG-50)] text-[#566F8F]"
            )}
            onClick={() => {
              if (showSubmit()) handleYes();
            }}
          >
            {isUpdating ? (
              <Loader Width={14} Height={14} loaderBg="white" />
            ) : (
              <div className="flex items-center justify-center gap-1.5">
                <Tick
                  width="12"
                  height="10"
                  strokeWidth="2.5"
                  stroke={showSubmit() ? "white" : "#566F8F"}
                />
                <span>OK</span>
              </div>
            )}
          </button>
        </div>
      </div>
      <Alert
        open={showConfirm}
        setOpen={setShowConfirm}
        content="changes"
        yesContent="Ok"
        noContent="Cancel"
        handleNo={() => setShowConfirm(false)}
        // handleYes={handleYes}
      />
    </div>
  );
}
